<template>
  <div class="language-switcher" :class="`language-switcher_${theme}`" role="group" :aria-label="$t('language.label')">
    <button
      v-for="item in LOCALES"
      :key="item"
      type="button"
      class="language-switcher__item"
      :class="{ 'language-switcher__item_active': locale === item }"
      :aria-pressed="locale === item"
      :aria-label="$t(`language.${item}_full`)"
      :lang="item === 'kz' ? 'kk' : 'ru'"
      @click="setLocale(item)"
    >
      {{ $t(`language.${item}`) }}
    </button>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { LOCALES, setLocale } from '@/plugins/i18n'

/**
 * Переключатель языка: две кнопки, а не выпадающий список — языков два, и выбор виден сразу.
 * Язык меняется без перезагрузки и запоминается в браузере.
 */
defineProps({
  // dark — на тёмной панели кабинета, light — на белой странице входа.
  theme: { type: String, default: 'dark' },
})
const { locale } = useI18n()
</script>

<style scoped lang="scss">
@use '@/assets/styles/base/variables' as *;

.language-switcher {
  display: inline-flex;
  gap: 2px;
  padding: 2px;
  border-radius: 8px;

  &__item {
    min-width: 40px;
    min-height: 32px;
    padding: 0 8px;
    border: none;
    border-radius: 6px;
    background: transparent;
    font: inherit;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;

    &:focus-visible {
      outline: 2px solid $color-tiffany-400;
      outline-offset: 1px;
    }
  }

  &_dark {
    background: rgba(255, 255, 255, 0.08);

    .language-switcher__item {
      color: $color-slate-300;

      &:hover {
        color: $color-white;
      }
    }

    .language-switcher__item_active {
      background: $color-primary;
      color: $color-white;
    }
  }

  &_light {
    background: $color-slate-100;

    .language-switcher__item {
      color: $color-slate-600;

      &:hover {
        color: $color-slate-900;
      }
    }

    .language-switcher__item_active {
      background: $color-white;
      color: $color-tiffany-700;
      box-shadow: 0 1px 2px $color-shadow;
    }
  }
}
</style>
